import { render, staticRenderFns } from "./DisableUser.vue?vue&type=template&id=cdec975a&scoped=true&"
import script from "./DisableUser.vue?vue&type=script&lang=js&"
export * from "./DisableUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdec975a",
  null
  
)

export default component.exports